//下拉头部添加class
$(window).scroll(function(){
  if($(window).width() > 1024){
      if($(window).scrollTop() >= 95){
        $(".pc_head").addClass('move');
      } else{
        $(".pc_head").addClass('move').removeClass('move');
      }
  }
});
// document js begin
$(document).ready(function() {

  //导航下拉
  $(".nav").slide({ type:"menu", titCell:".m", targetCell:".sub",effect:"slideDown",delayTime:300,triggerTime:0,returnDefault:true,defaultPlay:false});
  $(".intro_team_list").slide({titCell:".hd li", targetCell:".intro_team_txt_inner",defaultPlay:true});


  //去除移动端新闻详情页图片的宽高
  if($(window).width() < 1024){
    $('.news_content img').removeAttr('style').removeAttr('width').removeAttr('height');
  }
  //点击回到顶部
  $('#backtotop').click(function(){$('html,body').animate({scrollTop: '0px'}, 800);return false;});

  // sidebar b
  var trigger = $('.hamburger'),
  overlay = $('.overlay'),
  isClosed = false;
  trigger.click(function () {
    hamburger_cross();
  });
  function hamburger_cross() {
    if (isClosed == true) {
      overlay.hide();
      trigger.removeClass('is-open');
      trigger.addClass('is-closed');
      isClosed = false;
      event.preventDefault();
      $('body').css('overflow', 'auto');
    } else {
      overlay.show();
      trigger.removeClass('is-closed');
      trigger.addClass('is-open');
      isClosed = true;
      event.preventDefault();
      $('body').css('overflow', 'hidden');
    }
  }
  overlay.click(function () {
    overlay_cross();
  });
  function overlay_cross() {
    if (isClosed == true) {
      overlay.hide();
      trigger.removeClass('is-open');
      trigger.addClass('is-closed');
      isClosed = false;
      event.preventDefault();
      $('body').css('overflow', 'auto');
    } else {
      overlay.show();
      trigger.removeClass('is-closed');
      trigger.addClass('is-open');
      isClosed = true;
      event.preventDefault();
      $('body').css('overflow', 'hidden');

    }
    $('#warper').toggleClass('toggled');
  }
  $('[data-toggle="offcanvas"]').click(function () {
        $('#warper').toggleClass('toggled');
  });
  // sidebar e


});
// document js begin

window.onload = function() {
  var indexbanner = new Swiper('.index_banner',{
    autoplay : 5000,
    autoplayDisableOnInteraction : false,
    effect : 'fade',
    loop: true,
    pagination : '.index_banner_page',
    paginationClickable :true,
    prevButton:'.indexbanner_prev',
    nextButton:'.indexbanner_next',
    //其他设置
    onInit: function(swiper){ //Swiper2.x的初始化是onFirstInit
      swiperAnimateCache(swiper); //隐藏动画元素
      swiperAnimate(swiper); //初始化完成开始动画
    },
    onSlideChangeEnd: function(swiper){
      swiperAnimate(swiper); //每个slide切换结束时也运行当前slide动画
    }
  });
  var indexnews01 = new Swiper('.index_news01',{
    autoplay : 5000,
    autoplayDisableOnInteraction : false,
    loop: true,
    pagination : '.index_news01_page',
    paginationClickable :true,
    prevButton:'.indexnews01_prev',
    nextButton:'.indexnews01_next',
    //其他设置
  });
  var indexnews02 = new Swiper('.index_news02',{
    autoplay : 5000,
    autoplayDisableOnInteraction : false,
    loop: true,
    pagination : '.index_news02_page',
    paginationClickable :true,
    prevButton:'.indexnews02_prev',
    nextButton:'.indexnews02_next',
    //其他设置
  });
  var honorList = new Swiper('.honor_list',{
    slidesPerView : 4,
    spaceBetween : 50,
    autoplay : 5000,
    autoplayDisableOnInteraction : false,
    loop: true,
    //pagination : '.index_news02_page',
    //paginationClickable :true,
    prevButton:'.honor_list_prev',
    nextButton:'.honor_list_next',
    //其他设置
  });
}


// resize --------------------------------------------------------------------------------
$(window).resize(function() {


  $windowH = $(window).innerHeight();

  $('.winH').css('height', $windowH);
  $headerH = $('header').outerHeight();
  $footerH = $('footer').outerHeight();
  $('.winInnerH').css('height', $windowH-$headerH);
  $('.winInnerH02').css('height', $windowH-$headerH-$footerH);

}).trigger('resize');
// resize --------------------------------------------------------------------------------
